import React, { useRef, useState, useEffect } from 'react';
import './trending.scss'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Box, Container, Grid, Link } from '@mui/material';
function JyotirlingasTemple() {

   const vrShowData = [
  {
    id: 1,
    title: "Baidyanath Temple",
    image: "/assets/trending/baidyanath.webp",
  },
  {
    id: 2,
    title: "Trimbakeshwar Temple",
    image: "/assets/trending/trimbakeshwar.webp",
  },
  {
    id: 3,
    title: "Nageshwar Temple",
    image: "/assets/trending/nageshwar.webp",
  },
  {
    id: 4,
    title: "Grishneshwar Temple",
    image: "/assets/trending/grishneshwar.webp",
  },
  {
    id: 5,
    title: "Somnath Temple",
    image: "/assets/trending/somnath.webp",
  },
  {
    id: 6,
    title: "Mallikarjuna Temple",
    image: "/assets/trending/mallikarjuna.webp",
  },
  {
    id: 7,
    title: "Mahakaleshwar Temple",
    image: "/assets/trending/mahakaleshwar.webp",
  },
  {
    id: 8,
    title: "Omkareshwar Temple",
    image: "/assets/trending/omkareshwar.webp",
  },
  {
    id: 9,
    title: "Bhimashankar Temple",
    image: "/assets/trending/bhimashankar.webp",
  },
  {
    id: 10,
    title: "Kashi Vishwanath Temple",
    image: "/assets/trending/kashi-vishwanath.webp",
  },
  {
    id: 11,
    title: "Kedarnath Temple",
    image: "/assets/trending/kedarnath.webp",
  },
  {
    id: 12,
    title: "Rameshwaram Temple",
    image: "/assets/trending/rameshwaram.webp",
  },
  
];
   return (
      <>
         <Box className="trendingPage jyotirlings" >
            <Container maxWidth="lg">
               <Grid container spacing={2} justifyContent="left" alignItems="center">
                  <Grid size={{ xl: 10, lg: 10, md: 12, sm: 12, xs: 12 }} >
                     <Box className="VrBannerText vrBannerFull">
                        <div className='text-center'>
                           <h1 className="mt-4">12 JYOTIRLINGAS TEMPLES</h1>
                           <p>Experience the divine presence of Lord Shiva at the twelve revered Jyotirlinga temples spread across India. Uncover ancient traditions, sacred stories, and unforgettable spiritual journeys.
                           </p>
                           {/* <div className="d-flex gap-3 bannerButton">
                              <Box className="text-center mt-lg-3">
                                 <a href="#formBox" className="btn btn-success text-dark"><i className="fa fa-play ms-1 text-dark"></i> Play </a>
                              </Box>
                              <Box className="text-center mt-lg-3">
                                 <a href="/assets/trending/guideline.pdf" target="_blank" className="btn btn-warning text-dark"><i className="fa fa-arrow-right me-1 text-dark"></i>More Info </a>
                              </Box>
                           </div> */}
                        </div>
                     </Box>
                  </Grid>
               </Grid>
            </Container>
         </Box>

         <section className="darkTheme">
            
            <Box className="trendingSection">
               <Container maxWidth="lg">
                  <Grid container spacing={2} alignItems="stretch">
                     
                     {vrShowData.map((item) => (
                        <Grid
                           key={item.id}
                           size={{ xl: 3, lg: 3, md: 4, sm: 4, xs: 6 }}
                        >
                           <div className="swiperCitySlider">
                              <div className="templeCard templeDetailCard">
                              <img src={item.image} alt={item.title} />

                              <div className="overlay"></div>

                              <div className="cardContent">
                                 <h5>{item.title}</h5>
                              </div>
                              </div>
                           </div>
                        </Grid>
                        ))}


                     
                     
                  </Grid>


               </Container>
            </Box>
         </section>
      </>
   );
}
export default JyotirlingasTemple;